import mapKeys from 'lodash/mapKeys';

export const keysToLowerCase = <T>(obj: object) => {
  return mapKeys(obj, (value, key) => {
    return `${key}`.toLowerCase();
  }) as T;
};
